import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || '';
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const xeroService = {
  getAuthUrl: () =>
    axios.get(`${BASE}/api/xero/auth-url`, {
      ...auth(),
      params: { returnUrl: window.location.origin },
    }).then(r => r.data.url),

  getStatus: () =>
    axios.get(`${BASE}/api/xero/status`, auth()).then(r => r.data),

  selectTenant: (tenantId, tenantName) =>
    axios.post(`${BASE}/api/xero/select-tenant`, { tenantId, tenantName }, auth()).then(r => r.data),

  disconnect: () =>
    axios.delete(`${BASE}/api/xero/connection`, auth()).then(r => r.data),

  // Contact sync
  previewContacts: () =>
    axios.get(`${BASE}/api/xero/sync/contacts/preview`, auth()).then(r => r.data),

  applyContacts: (payload) =>
    axios.post(`${BASE}/api/xero/sync/contacts/apply`, payload, auth()).then(r => r.data),

  // Item sync
  previewItems: () =>
    axios.get(`${BASE}/api/xero/sync/items/preview`, auth()).then(r => r.data),

  applyItems: (payload) =>
    axios.post(`${BASE}/api/xero/sync/items/apply`, payload, auth()).then(r => r.data),

  // Lightweight: which productIds are linked to Xero
  getLinkedProducts: () =>
    axios.get(`${BASE}/api/xero/sync/items/linked-products`, auth()).then(r => r.data),

  // Invoice creation
  invoicePreflight: (orderId) =>
    axios.get(`${BASE}/api/xero/invoices/preflight/${orderId}`, auth()).then(r => r.data),

  createInvoice: (orderId) =>
    axios.post(`${BASE}/api/xero/invoices`, { orderId }, auth()).then(r => r.data),
};

export default xeroService;
